export function convertTime(ms: number) {
  var minute = Math.floor(ms / 60000);
  var second = ((ms % 60000) / 1000).toFixed(0);
  return minute + " phút " + (Number(second) < 10 ? "0" : "") + second + " giây";
}
